import { AIPPortletsModel } from "../../../libs/models/cbo/AIPPortletsModel";

export const AIPPortletDummyData: AIPPortletsModel[] = [
    {
        "id": 26132,
        "jobId": 23899,
        "outputId": "0f914969-f733-4111-9379-7e626e658abc",
        "userEmail": "utktrivedi@deloitte.com",
        "outputCategory": "Project PMO Documentation",
        "outputType": "Minutes of Meeting (MoM)",
        "inputFiles": [
            {
                "fileName": "CAT Core Ascend Demo  - Kaseya.ics",
                "fileDownloadLink": "https://amedeloitte.sharepoint.com/sites/Dummy_1729168772117/Shared%20Documents"
            },
            {
                "fileName": "CAT Core Ascend Demo  - Kaseya-20241008_190351-Meeting Recording-en-US transcript.vtt",
                "fileDownloadLink": "https://amedeloitte.sharepoint.com/sites/Dummy_1729168772117/Shared%20Documents"
            }
        ],
        "generationStatus": "Completed",
        "outputFiles": [
            {
                "fileName": "MoM_CAT Demo for Kaseya_23899.docx",
                "fileDownloadLink": "https://amedeloitte.sharepoint.com/:x:/r/sites/Dummy_1729168772117/_layouts/download.aspx?SourceURL=Shared%20Documents/General/Ascend%20Generative%20AI/Project%20PMO%20Documents/Minutes%20of%20Meeting%20(MoM)/Output%20Editable/MoM_CAT Demo for Kaseya_23899.docx",
                "fileUrl": "https://amedeloitte.sharepoint.com/sites/Dummy_1729168772117/_layouts/15/Doc.aspx?sourcedoc=%7B2B3C7506-F19C-4F36-B183-6CCF80A15E1D%7D&file=MoM_CAT%20Demo%20for%20Kaseya_23899.docx&action=default&mobileredirect=true"
            }
        ],
        "userPrompt": "",
        "aidingPrompt": "",
        "feedback": 80,
        "commentary": "",
        "teamSyncPending": false,
        "snowTicketId": "",
        "snowTicketLink": "",
        "errorIdentifierCode": "",
        "createdDate": "10/22/2024 1:15:55 PM",
        "createdBy": "Trivedi, Utkrisht",
        "modifiedDate": "10/22/2024 1:17:16 PM",
        "modifiedBy": "Trivedi, Utkrisht",
        "totalRecordCount": 5,
        "errorMessage": "",
        "currentPageNumber": 1
    },
    {
        "id": 26557,
        "jobId": 24266,
        "outputId": "2df0b536-43e1-44da-8819-752d0ef296d5",
        "userEmail": "utktrivedi@deloitte.com",
        "outputCategory": "Project PMO Documentation",
        "outputType": "Minutes of Meeting (MoM)",
        "inputFiles": [
            {
                "fileName": "CAT Core Ascend Demo  - Kaseya.ics",
                "fileDownloadLink": "https://amedeloitte.sharepoint.com/sites/Dummy_1729168772117/Shared%20Documents"
            },
            {
                "fileName": "CAT Core Ascend Demo  - Kaseya-20241008_190351-Meeting Recording.mp4",
                "fileDownloadLink": ""
            }
        ],
        "generationStatus": "In Progress",
        "outputFiles": [
            {
                "fileName": "MoM_Video mom_24266.docx",
                "fileDownloadLink": "https://amedeloitte.sharepoint.com/:x:/r/sites/Dummy_1729168772117/_layouts/download.aspx?SourceURL=Shared%20Documents/General/Ascend%20Generative%20AI/Project%20PMO%20Documents/Minutes%20of%20Meeting%20(MoM)/Output%20Editable/MoM_Video mom_24266.docx",
                "fileUrl": "https://amedeloitte.sharepoint.com/sites/Dummy_1729168772117/_layouts/15/Doc.aspx?sourcedoc=%7BB0D7020B-9636-4F6F-83F7-B0CB2B2994F8%7D&file=MoM_Video%20mom_24266.docx&action=default&mobileredirect=true"
            }
        ],
        "userPrompt": "",
        "aidingPrompt": "",
        "feedback": 60,
        "commentary": "",
        "teamSyncPending": false,
        "snowTicketId": "",
        "snowTicketLink": "",
        "errorIdentifierCode": "",
        "createdDate": "10/29/2024 12:18:19 PM",
        "createdBy": "Trivedi, Utkrisht",
        "modifiedDate": "10/29/2024 12:24:43 PM",
        "modifiedBy": "Trivedi, Utkrisht",
        "totalRecordCount": 5,
        "errorMessage": "",
        "currentPageNumber": 1
    },
    {
        "id": 29350,
        "jobId": 26643,
        "outputId": "e1806e8f-b572-4d8f-9baf-ce626e210779",
        "userEmail": "haithomas@deloitte.com",
        "outputCategory": "Project Functional Documentation",
        "outputType": "Minutes of Meeting (MoM)",
        "inputFiles": [
            {
                "fileName": "Input 1.vtt",
                "fileDownloadLink": "https://amedeloitte.sharepoint.com/sites/Dummy_1729168772117/Shared%20Documents"
            },
            {
                "fileName": "1_4 QA Discussion.ics",
                "fileDownloadLink": "https://amedeloitte.sharepoint.com/sites/Dummy_1729168772117/Shared%20Documents"
            }
        ],
        "generationStatus": "Completed",
        "outputFiles": [
            {
                "fileName": "MoM_test_26643.docx",
                "fileDownloadLink": "https://amedeloitte.sharepoint.com/:x:/r/sites/Dummy_1729168772117/_layouts/download.aspx?SourceURL=Shared%20Documents/General/Ascend%20Generative%20AI/Project%20PMO%20Documents/Minutes%20of%20Meeting%20(MoM)/Output%20Editable/MoM_test_26643.docx",
                "fileUrl": "https://amedeloitte.sharepoint.com/sites/Dummy_1729168772117/_layouts/15/Doc.aspx?sourcedoc=%7BA6CE58CF-0A09-4B00-9F48-E4A492428170%7D&file=MoM_test_26643.docx&action=default&mobileredirect=true"
            }
        ],
        "userPrompt": "",
        "aidingPrompt": "",
        "feedback": 80,
        "commentary": "",
        "teamSyncPending": false,
        "snowTicketId": "",
        "snowTicketLink": "",
        "errorIdentifierCode": "",
        "createdDate": "12/18/2024 6:44:47 PM",
        "createdBy": "Stagg, Hailey",
        "modifiedDate": "12/18/2024 6:46:20 PM",
        "modifiedBy": "Stagg, Hailey",
        "totalRecordCount": 5,
        "errorMessage": "",
        "currentPageNumber": 1
    },
    {
        "id": 32186,
        "jobId": 28951,
        "outputId": "f918c79c-22d4-4eb7-b40e-13791f69dddf",
        "userEmail": "haithomas@deloitte.com",
        "outputCategory": "Project PMO Documentation",
        "outputType": "Minutes of Meeting (MoM)",
        "inputFiles": [
            {
                "fileName": "AutoPMO - CAT & COE Weekly Collaboration Session-20241022_090227-Meeting Recording 1 (2).mp4",
                "fileDownloadLink": ""
            },
            {
                "fileName": "AutoPMO - CAT  COE Weekly Collaboration Session (2).ics",
                "fileDownloadLink": "https://amedeloitte.sharepoint.com/sites/Dummy_1729168772117/Shared%20Documents"
            },
            {
                "fileName": "AutoPMO - CAT & COE Weekly Collaboration Session-20241022_090227-Meeting Recording 1 (2).mp4.txt",
                "fileDownloadLink": "https://amedeloitte.sharepoint.com/sites/Dummy_1729168772117/Shared%20Documents/General/Ascend%20Generative%20AI/Project%20PMO%20Documents/Minutes%20of%20Meeting%20(MoM)/Input/28951/AutoPMO%20-%20CAT%20%26%20COE%20Weekly%20Collaboration%20Session-20241022_090227-Meeting%20Recording%201%20(2).mp4.txt"
            }
        ],
        "generationStatus": "Cancelled",
        "outputFiles": [],
        "userPrompt": "generate basic meeting minutes and attendance ",
        "aidingPrompt": "",
        "feedback": 0,
        "commentary": "",
        "teamSyncPending": false,
        "snowTicketId": "",
        "snowTicketLink": "",
        "errorIdentifierCode": "",
        "createdDate": "2/17/2025 10:24:44 PM",
        "createdBy": "Stagg, Hailey",
        "modifiedDate": "2/17/2025 10:29:00 PM",
        "modifiedBy": "Stagg, Hailey",
        "totalRecordCount": 5,
        "errorMessage": "Job cancelled by user",
        "currentPageNumber": 1
    },
    {
        "id": 32187,
        "jobId": 28952,
        "outputId": "9561563b-d07a-4485-8736-3c73e23e3bd9",
        "userEmail": "haithomas@deloitte.com",
        "outputCategory": "Project PMO Documentation",
        "outputType": "Minutes of Meeting (MoM)",
        "inputFiles": [
            {
                "fileName": "AutoPMO - CAT  COE Weekly Collaboration Session (2).ics",
                "fileDownloadLink": "https://amedeloitte.sharepoint.com/sites/Dummy_1729168772117/Shared%20Documents"
            },
            {
                "fileName": "AutoPMO - CAT & COE Weekly Collaboration Session-20241022_090227-Meeting Recording 1 (2).mp4",
                "fileDownloadLink": ""
            },
            {
                "fileName": "AutoPMO - CAT & COE Weekly Collaboration Session-20241022_090227-Meeting Recording 1 (2).mp4.txt",
                "fileDownloadLink": "https://amedeloitte.sharepoint.com/sites/Dummy_1729168772117/Shared%20Documents/General/Ascend%20Generative%20AI/Project%20PMO%20Documents/Minutes%20of%20Meeting%20(MoM)/Input/28952/AutoPMO%20-%20CAT%20%26%20COE%20Weekly%20Collaboration%20Session-20241022_090227-Meeting%20Recording%201%20(2).mp4.txt"
            }
        ],
        "generationStatus": "Failed",
        "outputFiles": [
            {
                "fileName": "MoM_test1_28952.docx",
                "fileDownloadLink": "https://amedeloitte.sharepoint.com/:x:/r/sites/Dummy_1729168772117/_layouts/download.aspx?SourceURL=Shared%20Documents/General/Ascend%20Generative%20AI/Project%20PMO%20Documents/Minutes%20of%20Meeting%20(MoM)/Output%20Editable/MoM_test1_28952.docx",
                "fileUrl": "https://amedeloitte.sharepoint.com/sites/Dummy_1729168772117/_layouts/15/Doc.aspx?sourcedoc=%7B5C69039B-CE76-410A-AB24-E1A861236B79%7D&file=MoM_test1_28952.docx&action=default&mobileredirect=true"
            }
        ],
        "userPrompt": "",
        "aidingPrompt": "",
        "feedback": 0,
        "commentary": "",
        "teamSyncPending": false,
        "snowTicketId": "",
        "snowTicketLink": "",
        "errorIdentifierCode": "",
        "createdDate": "2/17/2025 10:28:42 PM",
        "createdBy": "Stagg, Hailey",
        "modifiedDate": "2/17/2025 10:36:39 PM",
        "modifiedBy": "Stagg, Hailey",
        "totalRecordCount": 5,
        "errorMessage": "",
        "currentPageNumber": 1
    }
]

export enum AIPGenerationStatus {
    Completed = 'Completed',
    InProgress = 'In Progress',
    Failed = 'Failed',
    Cancelled = 'Cancelled'
}

export enum AIPRating {
    NA='N/A',
    NotProvided= 'Not Provided',
}

export enum AIPReportType {
    WeeklyStatusReport = 'Weekly Status Report',
    MinutesOfMeeting = 'Minutes of Meeting (MoM)',
    RaidLog = 'RAID Log'
}
